import { useEffect } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { PENDING_INVITE_KEY, parseInviteTokenFromInput } from '@/lib/invite-links';

/**
 * Handles /invite/:token (universal link path).
 * Stores only the extracted token and redirects to join-invite so auth + join flow can run.
 */
export default function InviteTokenRedirect() {
  const { token: tokenParam } = useLocalSearchParams<{ token: string }>();
  const router = useRouter();

  useEffect(() => {
    if (!tokenParam || typeof tokenParam !== 'string') {
      router.replace('/');
      return;
    }
    const token = parseInviteTokenFromInput(tokenParam) || tokenParam.trim();
    if (!token) {
      router.replace('/');
      return;
    }
    const run = async () => {
      await AsyncStorage.setItem(PENDING_INVITE_KEY, token);
      router.replace(`/join-invite?token=${encodeURIComponent(token)}` as any);
    };
    run();
  }, [tokenParam, router]);

  return null;
}
